export const marketingRu = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Бесплатный Quickstart',
  'marketing.free.seo.description':
    'Получи бесплатный Quickstart Grymwyrd — правила и приключение одной ночи, которое можно запустить сегодня. Войди в Сумерки.',
  'marketing.free.eyebrow': 'Твой бесплатный пропуск',
  'marketing.free.heading': 'Войди в Сумерки — бесплатно',
  'marketing.free.subheadLead': 'The',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— основные правила плюс приключение одной ночи, которое ты сможешь запустить сегодня. Скажи нам, куда его отправить.',
  'marketing.free.benefit.rules.title': 'Правила',
  'marketing.free.benefit.rules.body': 'Всё, что нужно для игры, уложено в quickstart.',
  'marketing.free.benefit.oneShot.title': 'Приключение одной ночи',
  'marketing.free.benefit.oneShot.body': 'Готовое к запуску хоррор-приключение для твоей первой ночи.',
  'marketing.free.benefit.livingWorld.title': 'Живой мир',
  'marketing.free.benefit.livingWorld.body': 'Связь с энциклопедией, картами и еженедельными обновлениями.',
  'marketing.free.playInstead.heading': 'Предпочитаешь сразу играть?',
  'marketing.free.playInstead.body':
    'Создай своего первого персонажа и пройди 10-минутный соло-тест — без покупок, без обязательств.',
  'marketing.free.playInstead.cta': 'Создать персонажа',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Что-то пошло не так. Попробуй ещё раз.',
  'marketing.leadForm.ready': 'Твой бесплатный Quickstart готов.',
  'marketing.leadForm.downloadCta': 'Скачать Quickstart',
  'marketing.leadForm.alsoEmailed': 'Мы также отправили ссылку на твою почту.',
  'marketing.leadForm.checkInbox': 'Проверь свою почту — твой бесплатный Quickstart в пути.',
  'marketing.leadForm.emailPlaceholder': 'you@example.com',
  'marketing.leadForm.emailAriaLabel': 'Email адрес',
  'marketing.leadForm.defaultCta': 'Отправить мне Quickstart',
  'marketing.leadForm.privacyNote':
    'Никакого спама — только Quickstart и иногда новые события мира. Отпишись в любой момент.',
} as const
